export class ChangeWallSizeAction {

  public readonly config: {};

  constructor(config) {
    this.config = config;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ChangeWallSizeAction.ts